import { GroupBox } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { BoxFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';
import { useAppDispatch } from '../../../store/hooks';
import form from '../../../store/slices/form';

import FormControlContainer, {
  TFormControlConnectorProps,
} from './FormControlContainer';
import { useFormGroupErrors } from './useFormGroupErrors';

interface Props extends TFormControlConnectorProps {
  control: BoxFormControlViewModel;
}

const FormGroupControl: React.FC<Props> = ({
  areHintsShown,
  control,
  formId,
  warning,
}) => {
  const dispatch = useAppDispatch();
  const { errors } = useFormGroupErrors(formId, control.name);
  const contentClassName = control.fullHeightGroup
    ? 'row full-height'
    : 'row items-center';

  if (!control.children.length || !control.visible) {
    return null;
  }

  const handleCollapse = (collapsed: boolean) => {
    dispatch(
      form.updateControlProp({
        formId,
        field: control.name,
        propName: 'collapsed',
        propValue: collapsed,
      })
    );
  };

  return (
    <GroupBox
      className={control.fullHeightGroup ? 'full-height' : undefined}
      disabled={control.disabled}
      {...(areHintsShown && { hint: control.hint })}
      label={control.noLabel ? '' : control.label}
      borderless={control.borderless}
      collapsible={control.collapsible}
      collapsed={control.collapsed}
      warning={warning || errors.size > 0}
      onCollapse={handleCollapse}
    >
      <GroupBox.Content className={contentClassName}>
        {control.children.map(child => (
          <FormControlContainer
            key={child}
            name={child}
            formId={formId}
            disabled={control.disabled}
          />
        ))}
      </GroupBox.Content>
    </GroupBox>
  );
};

export default FormGroupControl;
